module.exports = __webpack_public_path__ + "static/media/man w.beer-bw.a99b47e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/thumbs/man w.beer-bw.jpg
// module id = 459
// module chunks = 0